export const GoogleMapsAPI = "AIzaSyAdcMB_hIZQhoki88YBFvbNwry1einAEC0";
